import { FileSpreadsheet } from 'lucide-react'
import type { UniversalNodeSchema } from '../universal-node-schema'
import { UniversalNodeRegistry } from '../universal-node-schema'

const csvDataSchema: UniversalNodeSchema = {
  type: 'csvData',
  displayName: 'CSV Data',
  category: 'data',
  icon: FileSpreadsheet,
  description: 'Import and display CSV file data with drag and drop support',
  deprecated: true,
  inputs: [],
  outputs: [
    {
      id: 'data',
      displayName: 'CSV Data',
      type: 'array',
    },
  ],
  parameters: [
    {
      name: 'fileName',
      displayName: 'File Name',
      type: 'text',
      default: '',
    },
    {
      name: 'csvContent',
      displayName: 'CSV Content',
      type: 'text',
      default: '',
    },
    {
      name: 'headers',
      displayName: 'Headers',
      type: 'text',
      default: '',
    },
    {
      name: 'rowCount',
      displayName: 'Row Count',
      type: 'int',
      default: 0,
    },
    {
      name: 'selectedColumns',
      displayName: 'Selected Columns',
      type: 'text',
      default: '[]',
    },
  ],
}

export const csvSchemas: UniversalNodeSchema[] = [csvDataSchema]

export function registerCSVSchemas() {
  csvSchemas.forEach((schema) => {
    UniversalNodeRegistry.register(schema)
  })
}
